<section class="start-page">
  <div class="container-fluid start-page-shell">
    <div class="row start-page-row g-0">
      <div class="col-12 col-md-6 start-page-left">
        <div class="container start-page-left-inner">

          <div class="left-sec common-spacing">
            <!--  *ngIf="isContinueClicked==false" -->
            <!-- <div class="welcome">
              <h2>Welcome to Opinionest</h2>
              <p>Online surveys, chosen just for you, make earning rewards easy. No delays, zero conflicts. Share your
                voice and start minting bucks With assured referral rewards, get your game on with your friends. Inspire
                your acquaintances and earn when they earn. All this is possible in one place—Opinionest.</p>
                <div *ngIf="throttleDescisionCode == 2">
                <form [formGroup]="form">

                  <div class="form-check p-0 mt-3" >
                    <re-captcha id="recaptcha" formControlName="recaptcha"
                      (resolved)="onCaptchaResolved($event)">
                    </re-captcha>
                  </div>
                  <div *ngIf="submittedRecaptcha && form.get('recaptcha')?.invalid" class="text-danger">Recaptcha is required</div>
                </form>
              </div>
              <button type="button" *ngIf="isContinueButtonVisible==true" [disabled]="!rdInfoCheckService.RdResponsedone || invalidFormCheck || rdInfoCheckService.isProcessing" (click)="continueToggle()"
                class="btn btn-common mt-3" id="toggleButton">{{rdInfoCheckService.RdResponsedone ? 'Continue' : 'please wait...'}}</button>
              <label *ngIf="isContinueButtonVisible==false" class="btn btn-common mt-3">{{user_Message}}</label>
              <div class="mt-3" *ngIf="rdInfoCheckService.isProcessing">
                Processing....
              </div>
            </div> -->
            <!-- *ngIf="isContinueClicked==true" -->
            <div class="welcome w-100" [class.has-captcha]="throttleDescisionCode == 2">
              <h1 class="welcome-title">Welcome to Opinionest</h1>
              <p>Online surveys, chosen just for you, make earning rewards easy. No delays, zero conflicts. Share your
                voice and start minting bucks With assured referral rewards, get your game on with your friends. Inspire
                your acquaintances and earn when they earn. All this is possible in one place—Opinionest.</p>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="select_all" (change)="toggleAll($event)"
                  [checked]="allChecked">
                <label class="form-check-label" for="select_all" id="select_all_label">
                  Select All
                </label>
              </div>
              <div  class="form-check">
                <input class="form-check-input" (change)="IsChecked($event, 'terms')" [checked]="isTermsChecked"
                  type="checkbox" value="" id="terms_condition">
                <label class="form-check-label" for="terms_condition">
                  I agree to the <a href="https://opinionest.com/terms-and-conditions" target="_blank"
                    class="link">Terms and
                    Conditions</a>
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" (change)="IsChecked($event, 'privacy')" [checked]="isPrivacyChecked"
                  type="checkbox" value="" id="privacy_policy">
                <label class="form-check-label" for="privacy_policy">
                  I agree to the <a href="https://opinionest.com/privacy-policy" target="_blank" class="link">Privacy
                    Policy</a>
                </label>
              </div>
              <div class="captcha-block" *ngIf="throttleDescisionCode == 2">
                <form [formGroup]="form">
                  <re-captcha id="recaptcha" formControlName="recaptcha" (resolved)="onCaptchaResolved($event)">
                  </re-captcha>
                  <div *ngIf="submittedRecaptcha && form.get('recaptcha')?.invalid" class="text-danger captcha-error">Recaptcha is
                    required</div>
                </form>
              </div>
              <div class="d-flex gap-3 start-page-actions">
                <button  *ngIf="isContinueButtonVisible==true" type="button" [disabled]="!rdInfoCheckService.RdResponsedone || this.rdInfoCheckService.doRedirect || isError||rdInfoCheckService.isProcessing || invalidFormCheck"
                  class="btn btn-common" (click)="onSubmit()" [innerHTML]="rdInfoCheckService.RdResponsedone && !this.rdInfoCheckService.doRedirect ? 'Continue' : 'please wait...'"></button>
                <label *ngIf="isContinueButtonVisible==false" class="btn btn-common">{{user_Message}}</label>
              </div>
              <p class="mt-2 mb-0">
                Dropout API: {{ dropoutDebugCount }} — {{ dropoutDebugLast }}
                <button type="button" class="btn btn-sm btn-outline-common ml-2" (click)="clearDropoutDebug()">Clear</button>
              </p>
              <div class="processing-note" *ngIf="rdInfoCheckService.isProcessing">
                Processing....
              </div>
            </div>
          </div>
        </div>
        <div class="phone-desktop-banner" aria-hidden="true">
          <img src="../../../assets/images/right-img-1.png" alt="" />
        </div>
      </div>
      <div class="col-md-6 p-0 right-sec start-page-carousel">
        <div class="container h-100">
          <div class="common-spacing text-center h-100">
            <div class="slider">
              <div class="owl-carousel owl-theme">
                <div class="item">
                  <img src="../../../assets/images/right-img-1.png" class="img-fluid" width="800" height="800" />
                </div>
                <div class="item">
                  <img src="../../../assets/images/right-img.png" class="img-fluid" width="800" height="800" />
                </div>
                <div class="item">
                  <img src="../../../assets/images/right-img-2.png" class="img-fluid" width="800" height="800" />
                </div>
                <div class="item">
                  <img src="../../../assets/images/right-img-3.png" class="img-fluid" width="800" height="800" />
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="rd-block-snack" *ngIf="rdBlockNotice">{{ rdBlockNotice }}</div>
